import styled from 'styled-components'
import { rem } from 'polished'

import Breadcrumb from 'components/Breadcrumb'
import Dropdown from 'components/Dropdown'

export const DropdownTarget = styled(Breadcrumb.Item)`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: ${({ theme }) => theme.fontSizes.smaller};
`

export const DropdownIcon = styled(Dropdown.Chevrons)`
  margin-left: ${rem(8)};
`

export const DropdownContentContainer = styled.div`
  clip-path: inset(0px 0px 0px 0px round 4px);
  max-height: 80vh;
  overflow-y: auto;
  max-width: calc(100vw - 20px);
  padding: 8px 0;
`
